import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/static/decola_logos/new_logo_sem_slogan_white.svg'


const _withScopeId = n => (_pushScopeId("data-v-094d6c5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "call" }
const _hoisted_2 = { class: "call__top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "call__title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "call__details" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "call__image",
      width: "500",
      src: _imports_0,
      alt: "Logo do decola"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "call__slogan" }, "a nossa escola")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "call__description" }, " Abrindo espaço para o seu crescimento e desenvolvimento. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_register_modal = _resolveComponent("register-modal")!
  const _component_login = _resolveComponent("login")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleLogin && _ctx.toggleLogin(...args))),
        class: "call__button"
      }, "Login"),
      (_ctx.isModalOpened)
        ? (_openBlock(), _createBlock(_component_register_modal, {
            key: 0,
            onToggleRegisterModal: _ctx.toggleRegisterModal
          }, null, 8, ["onToggleRegisterModal"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleLogin && _ctx.toggleLogin(...args))),
        class: "trigger-area"
      }, [
        _createVNode(_component_login, {
          onRecoverPassword: _cache[1] || (_cache[1] = 
            () => {
              _ctx.toggleLogin();
              _ctx.$router.push({
                name: 'home',
                params: { resetPass: 'reset-password', resetBy: 'identity' }
              });
            }
          ),
          onToggleLogin: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleLogin())),
          onToggleRegisterModal: _cache[3] || (_cache[3] = 
            () => {
              _ctx.toggleLogin();
              _ctx.toggleRegisterModal();
            }
          ),
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
          class: "call__login"
        })
      ])
    ])
  ]))
}